// This convenience function allows us to apply multiple values to the same
// style property without adding more elements to the DOM.
// It sets the property if it doesn't exist or appends the value to it if it does.
export const concatenateStyle = (
  props: Record<string, any>,
  key: string,
  value: any
) => {
  if (!props.style) {
    props.style = {};
  }

  if (Object.hasOwn(props.style, key)) {
    props.style[key] += ` ${value}`;
  } else {
    props.style = { ...props.style, [key]: value };
  }

  return props;
};
